import { useEffect, useState } from 'react'
import Consts from './Const'
import './LastMatches.css'
import { FlexDiv } from './flexdiv'
import { DateTimeHelper } from './DateTimeHelper'

interface IMatchResultPlayer {
  Username: string
  Avatar: string
}

interface IMatchResult {
  Team1Score: number
  Team2Score: number
  Team1Players: IMatchResultPlayer[]
  Team2Players: IMatchResultPlayer[]
  PointForWinner: number
  Timestamp: Date | string
}

interface ILastMatchProps {
  matchResult: IMatchResult
  matchIdx: number
}

const LastMatch = ({ matchResult, matchIdx }: ILastMatchProps) => {  
  return (
    <FlexDiv align="center" style={{ padding: '1.5vh', backgroundColor: '#666' }} direction="column">
      <FlexDiv align="center" style={{ zIndex: 1 }}>
        <FlexDiv direction="column" gap={8}>
          {matchResult.Team1Players.map((p, pIdx) => {
            return (
              <FlexDiv key={`team1${pIdx}`} direction="column" align="center">
                <img
                  key={`LastMatch-Player-avatar1-${matchIdx}-${pIdx}`}
                  className="LastMatch-Player-avatar"
                  src={`data:image/png;base64,${p.Avatar ?? Consts.noAvatar}`}
                  alt="Player avatar"
                  style={{ border: matchResult.Team1Score > matchResult.Team2Score ? '1px solid lime' : '1px solid red' }}
                />
                <FlexDiv
                  style={{
                    color: 'white',
                    whiteSpace: 'nowrap',
                    maxWidth: '4vh',
                    overflow: 'hidden',
                    fontSize: '1.3vh',
                    marginTop: '0.1vh',
                    fontWeight: 'bold',
                  }}
                >
                  {p.Username}
                </FlexDiv>
              </FlexDiv>
            )
          })}
        </FlexDiv>
        <FlexDiv align="center" style={{ fontSize: '2.5vh', margin: 10 }} direction="column">
          <FlexDiv style={{ color: '#fff', whiteSpace: 'nowrap' }}>
            {matchResult.Team1Score} - {matchResult.Team2Score}
          </FlexDiv>
          <FlexDiv style={{ color: '#fff', whiteSpace: 'nowrap' }}>{matchResult.PointForWinner}p</FlexDiv>
        </FlexDiv>
        <FlexDiv direction="column" gap={8}>
          {matchResult.Team2Players.map((p, pIdx) => {
            return (
              <FlexDiv key={`team2${pIdx}`} direction="column" align="center">
                <img
                  key={`LastMatch-Player-avatar2-${matchIdx}-${pIdx}`}
                  className="LastMatch-Player-avatar"
                  src={`data:image/png;base64,${p.Avatar ?? Consts.noAvatar}`}
                  alt="Player avatar"
                  style={{ border: matchResult.Team1Score < matchResult.Team2Score ? '1px solid lime' : '1px solid red' }}
                />
                <FlexDiv
                  style={{
                    color: 'white',
                    whiteSpace: 'nowrap',
                    maxWidth: '4vh',
                    overflow: 'hidden',
                    fontSize: '1.3vh',
                    marginTop: '0.1vh',
                    fontWeight: 'bold',
                  }}
                >
                  {p.Username}
                </FlexDiv>
              </FlexDiv>
            )
          })}
        </FlexDiv>
      </FlexDiv>
      <FlexDiv style={{ marginTop: '2vh', color: '#ccc', fontWeight: 'bold', fontSize: '1.4vh', fontStyle: 'italic' }}>
        {(matchResult.Timestamp as Date).hhmmddmmyyyy()}
      </FlexDiv>
    </FlexDiv>
  )
}

interface ILastMatchesProps {
  organizationId: string
  activityType: number
  baseUrl: string
  latestHistoryId: string
}

const LastMatches = ({ organizationId, activityType, baseUrl, latestHistoryId }: ILastMatchesProps) => {
  const [data, setData] = useState<IMatchResult[]>([])

  // baseUrl = 'http://localhost:27015'

  useEffect(() => {
    fetch(`${baseUrl}/api/lastMatches?organizationId=${organizationId}&activityType=${activityType}`)
      .then(res => {
        return res.json()
      })
      .then(data => {
        const lastMatches = (data as IMatchResult[]).map(mr => {
          return {
            ...mr,
            Timestamp: DateTimeHelper.convertJSONDateTime(mr.Timestamp as any as string),
          }
        })

        setData(lastMatches)
      })
      .catch(e => {
        setData([])
      })
  }, [baseUrl, latestHistoryId])

  if (!data.length) return null

  return (
    <FlexDiv style={{ width: '100%', height: '100%', justifyContent: 'center' }}>
      <FlexDiv
        style={{
          width: '100%',
          backgroundColor: '#888',
          border: '3px solid #444',
          flexDirection: 'column',
          gap: 8,
          borderRadius: '3vh',
          overflow: 'hidden',
        }}
        align="center"
      >
        <FlexDiv className="LastMatches-title">⚔️ Recent Matches</FlexDiv>
        <FlexDiv style={{ borderTop: '3px solid #444', width: '100%', minWidth: 0, overflow: 'clip', contain: 'inline-size', height: '100%' }}>
          {data.map((m, mIdx) => {
            const key = `lastMatch_${(m.Timestamp as Date).toISOString()}_${mIdx}`
            return (
              <FlexDiv key={key}>
                {mIdx !== 0 && <FlexDiv style={{ minWidth: 3, backgroundColor: '#444' }} />}
                <LastMatch matchResult={m} matchIdx={mIdx} />
              </FlexDiv>
            )
          })}
        </FlexDiv>
      </FlexDiv>
    </FlexDiv>
  )
}

export default LastMatches
